<template>
  <div>
    <div style="overflow: auto;height:70vh;width: calc(100vw - 488px);" id="areaMap" ref="areaMap"></div>
    <div ref="popup" class="popup" v-show="shopPopup"></div>
  </div>
</template>

<style>
</style>

<script>
import 'ol/ol.css';
import Map from 'ol/Map';
import View from 'ol/View';
import ImageLayer from "ol/layer/Image";
import {ImageStatic} from "ol/source";
import {Projection} from "ol/proj";
import {getCenter} from "ol/extent";
import * as olInteraction from 'ol/interaction'
import DragRotateAndZoom from 'ol/interaction/DragRotateAndZoom'
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import {Point} from "ol/geom";
import {FullScreen} from "ol/control";
import {defaults as defaultControls} from "ol/control";
import Zoom from "ol/control/Zoom";
import {Icon, Style, Text} from 'ol/style';
import Fill from "ol/style/Fill";
import Feature from 'ol/Feature';
import {Overlay} from "ol";


export default {
  name: "firePanelMap",
  props: ['areaList', 'indoorBg'],
  data() {
    return {
      areaMap: null, // 地图
      vectorSource: null,
      /* start
      *GIS地图参数*/
      map: null, // 地图
      // 鼠标点击事件对象
      mapClickHandler: null,
      // 鼠标悬浮事件对象
      mapOverHandler: null,
      // 漏水线图层集合
      slackLineLayers: [],
      imgx: 1432, // 当前地图宽
      imgy: 1002, // 当前地图高
      // 鼠标坐标管理器
      mousePositionControl: "",
      // 地图背景图层
      mapImageLayers: null,
      // 图标管理器
      iconLayer: null,
      // 鼠标悬浮图层
      hoverFeature: null,
      // 图标集合
      featureList: [],
      // 轮询显示图标设备名称定时器
      showDeviceTimer: null,
      // 定时更新设备图标
      updateDeviceIconTimer: null,
      // 循环判断内景图是否初始化
      createMapTimer: null,
      // 设备集合
      deviceList: [],
      // 是否显示堆叠层
      shopPopup: false
      /* end
      *GIS地图参数*/
    };
  },
  watch: {
    areaList() {
      this.shopPopup = false
      console.log("areaList", this.areaList, this.indoorBg)
      if (this.areaList != null && this.indoorBg != "" && this.indoorBg != null) {
        if (this.areaMap == null && this.indoorBg) {
          this.getBgImageInfo(this.initMap)
        } else {
          // 去掉地图背景图层
          this.areaMap.removeLayer(this.mapImageLayers)
          this.getBgImageInfo(this.changeDeviceMapImage)
        }
      }
    }
  },
  methods: {
    // 重新设置底图和设备图标
    changeDeviceMapImage() {
      // 重新设置地图背景图层
      this.getMapImageLayer();
      this.areaMap.addLayer(this.mapImageLayers)
      // 初始化图标图层
      this.initDevicePointList();
    },
    // 获取内景图图片宽高
    async getBgImageInfo(fucObject) {
      // 图片地址 后面加时间戳是为了避免缓存
      var img_url = window.g.ftpUrl + this.indoorBg;
      // 创建对象
      var img = new Image();
      // 改变图片的src
      img.src = img_url;
      var that = this;
      // 加载完成执行
      img.onload = await function () {
        that.imgy = img.height
        that.imgx = img.width
        fucObject()
      }
    },
    initMap() {
      let extent = [0, 0, this.imgx, this.imgy];  // 获取图片的宽高
      // [minx, miny, maxx, maxy].
      let projection = new Projection({
        code: "xkcd-image",
        units: "pixels",
        extent: extent
      });
      this.mapImageLayers = null;
      this.mapImageLayers = new ImageLayer({
        source: new ImageStatic({
          url: window.g.ftpUrl + this.indoorBg,  // 静态地图
          projection: projection,
          imageExtent: extent
        })
      })
      this.areaMap = new Map({
        target: "areaMap",
        // shift控制旋转
        interactions: olInteraction.defaults().extend([new DragRotateAndZoom()]),
        // 缩放等级zoom当前缩放程度，maxZoom最大缩放程度
        view: new View({
          projection: projection,
          center: getCenter(extent),
          // 当前缩放倍数
          zoom: 2.5,
          // 最大缩放倍数
          maxZoom: 7
        }),
        controls: defaultControls({
          rotate: true,
        }).extend([
          new FullScreen({
            tipLabel: "全屏"
          }),
          new Zoom({
            zoomInTipLabel: "放大",
            zoomOutTipLabel: "缩小"
          })
        ])
      });
      this.areaMap.addLayer(this.mapImageLayers);
      /**
       * 添加图标集合
       */
      this.addDevicePointList()
      // 修改旋转鼠标悬浮tip
      document.getElementsByClassName('ol-rotate-reset')[1].attributes.title.nodeValue = '重置旋转'
    },
    // 设置地图背景图片
    getMapImageLayer() {
      let extent = [0, 0, this.imgx, this.imgy];  // 获取图片的宽高
      // [minx, miny, maxx, maxy].
      let projection = new Projection({
        code: "xkcd-image",
        units: "pixels",
        extent: extent
      });
      this.mapImageLayers = null;
      this.mapImageLayers = new ImageLayer({
        source: new ImageStatic({
          url: window.g.ftpUrl + this.indoorBg,  // 静态地图
          projection: projection,
          imageExtent: extent
        })
      })
      // 重新设置中心点
      this.areaMap.getView().setCenter(getCenter(extent))
      this.areaMap.getView().setZoom(1);
    },
    // 添加设备图标集合
    initDevicePointList() {
      // 清除GIS地图中图标更新器
      if (this.updateDeviceIconTimer) {
        clearInterval(this.updateDeviceIconTimer);
        this.updateDeviceIconTimer = null;
      }
      // 添加图标集合
      this.updateDeviceIconTimer = setInterval(() => {
        // 清除map图标
        this.delDevicePoint()
        if (this.areaList != null && this.iconLayer.getSource().getFeatures().length === 0) {
          this.addDevicePointList();
          clearInterval(this.updateDeviceIconTimer);
          this.updateDeviceIconTimer = null;
        }
      }, 1000)
    },
    // 根据id_删除图标并清除该图层所有点击和悬浮事件
    delDevicePoint() {
      // 初始化设备点位集合图层
      this.featureList = [];
      if (this.iconLayer.getSource().getFeatures() != null && this.iconLayer.getSource().getFeatures().length != 0) {
        this.areaMap.un('pointermove', this.mapOverHandler)
        this.areaMap.un('singleclick', this.mapClickHandler)
        this.iconLayer.getSource().getFeatures().forEach(item => {
          this.iconLayer.getSource().removeFeature(this.iconLayer.getSource().getFeatureById(item.id_));
        })
      }
    },
    // 初始化设备图标集合图层
    addDevicePointList() {
      const vectorSource = new VectorSource()
      this.iconLayer = new VectorLayer({
        source: vectorSource
      })
      // 只显示设置了点位的区域
      let bindList = this.areaList.filter(item => (item.xoffset && item.yoffset))
      if (bindList != null && bindList.length != 0) {
        bindList.forEach(item => {
          this.addDevicePoint(item);
        })
      }
      // 等待图标图层添加完再绑定鼠标悬浮和点击事件
      if (this.featureList != null && this.featureList.length != 0) {
        // 将图标数组添加到图层中
        this.iconLayer.getSource().addFeatures(this.featureList)
        // 添加图层
        this.areaMap.addLayer(this.iconLayer)
        this.mapOver();
        this.mapClick();
      }
    },
    // 添加图标
    addDevicePoint(item) {
      let convertX = item.xoffset * this.imgx / 100;
      let convertY = this.imgy - (item.yoffset * this.imgy / 100);
      // 设置图片位置
      let iconFeature = new Feature({
        geometry: new Point([convertX, convertY])
      })
      // 设置样式，这里使用图片
      iconFeature.setStyle([
        new Style({
          image: new Icon({
            // 指定锚 x 值的单位。的值'fraction'表示 x 值是图标的一部分。的值'pixels'表示以像素为单位的 x 值。
            anchorXUnits: 'fraction',
            // 左下角为原点
            anchorOrigin: 'bottom-left',
            anchorYUnits: 'fraction',
            anchor: [0.5, 0],
            src: item.status == 0 ? '/static/images/menus/areaIcon.png' : '/static/images/menus/areaAlarmIcon.png'
          }),
          zIndex: 3
        }),
        new Style({
          text: new Text({
            text: item.cnName,
            font: "14px Microsoft YaHei",
            offsetY: -15,
            offsetX: 15,
            padding: [5, 10, 5, 15],
            textAlign: 'left',
            backgroundFill: new Fill({
              // eslint-disable-next-line no-constant-condition
              color: item.status == 0 ? 'rgba(0,111,255,0.5)' : 'rgba(249, 88, 87, 0.5)'//提示背景色
            }),
            fill: new Fill({
              color: "#fff"
            }),
          }),
          zIndex: 2
        }),
      ])
      // 提取区域告警集合
      if (item.realTimeList != null && item.realTimeList.length != 0) {
        let realTimeListCopy = []
        item.realTimeList.forEach(alarmInfo => {
          realTimeListCopy.push('<p></p>' + alarmInfo.msg + "---" + alarmInfo.createTime)
        })
        iconFeature.realTimeList = realTimeListCopy
      }
      // 给图层设置设备图标name和id属性，用作独立 区分
      iconFeature.cnName = item.cnName
      iconFeature.id = item.id
      iconFeature.id_ = item.id;
      iconFeature.alarmStatus = item.status
      // 将图片Feature添加到Source
      this.featureList.push(iconFeature)
    },
    // 监听地图点击事件
    mapClick() {
      var _this = this;
      this.mapClickHandler = evt => {
        console.log("当前点击坐标x,y", evt.coordinate);
        var feature = _this.areaMap.forEachFeatureAtPixel(evt.pixel,
          function (feature) {
            return feature
          })
        if (feature != undefined && feature.alarmStatus == 1) {
          let elPopup = this.$refs.popup
          elPopup.innerHTML = feature.realTimeList
          let popup = new Overlay({
            element: elPopup,
            positioning: 'top-center',
            stopEvent: true,
            offset: [90, 0]
          })
          this.shopPopup = true
          popup.setPosition(feature.getGeometry().getCoordinates())
          this.areaMap.addOverlay(popup)
        } else {
          this.shopPopup = false
        }
      }
      this.areaMap.on('singleclick', this.mapClickHandler)
    },
    // 鼠标悬浮
    mapOver() {
      const _this = this
      this.mapOverHandler = evt => {
        // 手指效果
        var pixel = _this.areaMap.getEventPixel(evt.originalEvent);
        var hit = _this.areaMap.hasFeatureAtPixel(pixel);
        // 高亮区域取消手指效果
        const hoverFeature = _this.areaMap.getFeaturesAtPixel(pixel);
        this.$refs.areaMap.style.cursor = hit && hoverFeature.length >= 1 ? 'pointer' : '';
        _this.areaMap.forEachFeatureAtPixel(evt.pixel,
          function (feature) {
            return feature
          })
      }
      this.areaMap.on('pointermove', this.mapOverHandler)
    },
  },
  destroyed() {
    clearInterval(this.showDeviceTimer)
    this.showDeviceTimer = null;
    clearInterval(this.updateDeviceIconTimer);
    this.updateDeviceIconTimer = null;
    this.shopPopup = false
  }
}
</script>

<style scoped>
::v-deep .ol-rotate {
  /* 设置地图旋转回正按钮位置，避免与全屏按钮重叠*/
  right: 3em;
}

.popup {
  padding: 10px 16px;
  border-radius: 8px;
  color: black;
  background-color: rgb(225, 203, 154);
  box-shadow: 0 0 10px rgb(11, 59, 103, .5);
  height: 300px;
  width: 200px;
  overflow: auto;
}

::v-deep -webkit-scrollbar-track {
  background-color: unset !important;
}

::v-deep -webkit-scrollbar {
  background-color: unset !important;
}
</style>
